var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1106",
    "data-name": "Rectangle 1106",
    width: 22,
    height: 22,
    transform: "translate(663 75)",
    fill: "#c06c84",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder",
    transform: "translate(-663 -75)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-2",
    "data-name": "folder",
    transform: "translate(663 75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M.645,4.026h10l-1.084-2.1a.645.645,0,0,0-.573-.349H1.6a.645.645,0,0,0-.611.441L.314,4.055a1.937,1.937,0,0,1,.331-.029Z",
    fill: "#c06c84"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2540",
    "data-name": "Group 2540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M21.355,20.421H.645A.645.645,0,0,1,0,19.776V5.96a.645.645,0,0,1,.645-.645H21.355A.645.645,0,0,1,22,5.96V19.776A.645.645,0,0,1,21.355,20.421Z",
    fill: "#c06c84"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.05c25e177befb10926e367f612e6f512.svg";
export { ForwardRef as ReactComponent };